
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1978"}},[_c('path',{attrs:{"data-name":"Rectangle 2704","fill":"none","d":"M0 0h24v24H0z"}}),_c('g',{attrs:{"data-name":"Group 1977","fill":"#adadad"}},[_c('path',{attrs:{"data-name":"Path 1304","d":"M12 2.403l9.983 6.656a.319.319 0 01.017.032L21.994 22H2.004V9.091a.322.322 0 01.017-.032l9.983-6.656m0-2.078a1.518 1.518 0 00-.832.229L.836 7.445A2.1 2.1 0 00.004 9v14a1 1 0 001 1h21.99a1 1 0 001-1L24 9a2.1 2.1 0 00-.832-1.555L12.832.554A1.515 1.515 0 0012 .325z"}}),_c('g',{attrs:{"data-name":"Group 1976","transform":"translate(-208.456 -375.841)"}},[_c('rect',{attrs:{"data-name":"Rectangle 2705","width":"4","height":"4","rx":"1","transform":"translate(215.568 384.935)"}}),_c('rect',{attrs:{"data-name":"Rectangle 2706","width":"4","height":"4","rx":"1","transform":"translate(221.568 390.935)"}}),_c('circle',{attrs:{"data-name":"Ellipse 253","cx":"2","cy":"2","r":"2","transform":"translate(215.568 390.935)"}}),_c('circle',{attrs:{"data-name":"Ellipse 254","cx":"2","cy":"2","r":"2","transform":"translate(221.693 384.935)"}})])])])])
          )
        }
      }
    